// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"35":"61c30035","92":"f694d26e","893":"ef7bdb9f"}[chunkId] + ".chunk.css";
};